/**
 * Глобальная регистрация компонентов
 */
import Vue from "vue";
import LeftMenu from "@/components/LeftMenu.vue";
import LeftBanner from "@/components/LeftBanner.vue";
import Cart from "@/components/Cart.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import TwoColPageWrapper from "@/components/TwoColPageWrapper.vue";
import DaOverlayIn from "@/components/DaOverlayIn.vue";
import DaPagination from "@/components/DaPagination.vue";
import DaImg from "~~/components/elems/DaImg.vue";
import DaYoutubePlayer from "~~/components/media/DaYoutubePlayer.vue";
import DaDialog from "~~/components/elems/DaDialog.vue";

Vue.component("LeftMenu", LeftMenu);
Vue.component("LeftBanner", LeftBanner);
Vue.component("Cart", Cart);
Vue.component("Breadcrumbs", Breadcrumbs);
Vue.component("TwoColPageWrapper", TwoColPageWrapper);
Vue.component("DaOverlayIn", DaOverlayIn);
Vue.component("DaPagination", DaPagination);
Vue.component("DaImg", DaImg);
Vue.component("DaYoutubePlayer", DaYoutubePlayer);
Vue.component("DaDialog", DaDialog);
